import '@/common/rem'
import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import i18n from './lang/index.js'
import TableMixin from './utils/tableMixins'
import unitMixin from './utils/unitMixin'
// 引入UIKIT CSS框架
import UIKit from 'uikit'
import resultHandle from '@/common/resultHandle'
import 'uikit/dist/css/uikit.min.css'
//
import 'element-ui/lib/theme-chalk/index.css'
import './styles/ccdc.scss'
import '@/styles/public.scss'
import '@/styles/index.scss'
import 'font-awesome/css/font-awesome.min.css'

import '@/styles/reset.scss'
import '@/styles/element-variables.scss' // 修改ui组件的主题色
import '@/styles/variables.scss'
import '@/styles/theme-variables.scss' // 主题色 CSS 变量（PoC 动态切换）
import '@/styles/element-theme-overrides.scss' // element-ui 组件主题色覆盖（跟随 CSS 变量）

// 在 Vue 渲染前恢复主题色，避免登录后页面闪烁
import { restoreThemeFromStorage } from '@/utils/theme';
restoreThemeFromStorage();

/** icon */
import '@/assets/iconfont/iconfont.css'
import '@/assets/styleIcon/iconfont.css'
import '@/assets/coldchainfont/iconfont.css'
import '@/assets/newIcon/iconfont.css'
import common from '@/utils/common.js'
import fromRules from '@/utils/validate.js'
import components from './components/index'
// import _global from '@/utils/treeUtil.js'
// brian---------------------------------------------------start
import '@/directive/has.js' // 指令权限
import '@/directive/tableLoading.js' // 监听表格触底加载
import '@/directive/selectLoading.js' // 监听select触底加载
import '@/directive/range.js' // 指令-给不在区间内的值设置指定样式
// import echarts from 'echarts'
// 版本升级
import echarts from '@/echart/echart.js'

import { wgs84togcj02 } from './utils/postion.js'
import loading from './components/loading/loading'

import '@/getInitdata.js'

// import VueGoogleMap from 'vue-google-maps'

Vue.prototype.$uikit = UIKit

// brian---------------------------------------------------end

Vue.use(loading)

Vue.use(components)

Vue.use(common)

Vue.mixin(TableMixin)
Vue.mixin(unitMixin)

// Vue.prototype.$_global = _global

Vue.prototype.$fromRules = fromRules // 注册成全局验证
Vue.prototype.$echarts = echarts
Vue.prototype.$wgs84togcj02 = wgs84togcj02
Vue.prototype.$resultHandle = resultHandle
if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })
    ],
    tracesSampleRate: 0.1,
    environment: process.env.NODE_ENV || 'production',
    release: `freshmon-web@${process.env.VUE_APP_VERSION || '1.1.0'}`,
    logErrors: true
  })
}

Vue.config.productionTip = false
Vue.use(Element, {
  size: 'mini',
  zIndex: 3000,
  i18n: (key, value) => i18n.t(key, value)
})

// Vue.use(VueGoogleMap, {
//   load: {
//     apiKey: 'AIzaSyBMTXwr968nvF7YHNjGSZfd2JqhJSNq0qk',
//     libraries: ['places'],
//     useBetaRenderer: false,
//   }
// })

window.vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
// 为实现Srcript与template相统一 将国际化函数监测点到window
window.$t = vm.$t.bind(vm)

// 该指令依赖于vue实例上的国际化  不采用预加载
import('@/directive/icon.js') // 图标转换指令

// 依赖于element
import('@/vueRewrite.js')
